import React from 'react';

import { Icon } from '../icons';

export const RiseIcon: Icon['component'] = ({ color, style, ...props }) => {
  return (
    <svg {...props} viewBox="0 0 32 32" fill={color} style={style}>
      <path d="M28.7534 5.00595C28.5978 4.62992 28.3686 4.27718 28.0658 3.96974C28.054 3.9578 28.0422 3.94596 28.0303 3.9342C27.4447 3.35753 26.6414 3.0013 25.7549 3C25.7532 3 25.7516 3 25.75 3H25.7494H9.5C7.70507 3 6.25 4.45507 6.25 6.25C6.25 8.04493 7.70507 9.5 9.5 9.5H17.9038L3.9519 23.4519C2.6827 24.7211 2.6827 26.7789 3.9519 28.0481C5.22111 29.3173 7.27889 29.3173 8.5481 28.0481L22.5 14.0962V22.5C22.5 24.2949 23.9551 25.75 25.75 25.75C27.5449 25.75 29 24.2949 29 22.5V6.25C29 5.80933 28.9123 5.38915 28.7534 5.00595Z" />
    </svg>
  );
};
